import React from "react";
import Button from "./Button";
import { CTA_URL, DOSSIER_URL, IMAGES, LANDING_COPY } from "../constants";

const Hero: React.FC = () => {
  const { hero } = LANDING_COPY;

  return (
    <section
      id="inicio"
      className="relative -mt-px flex min-h-[100svh] items-end overflow-hidden pb-24 pt-32 sm:items-center sm:pb-20 sm:pt-20"
    >
      <div className="absolute inset-0 bg-zinc-950">
        <video
          className="hero-video-kenburns h-full w-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        >
          <source src={IMAGES.heroVideo} type="video/mp4" />
        </video>
        {/* Subtle gradient to ensure text readability without hiding the video */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/10" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="animate-fade-in-up text-hero-shadow font-display text-4xl font-bold leading-tight text-white sm:text-5xl md:text-6xl lg:text-[4rem]">
            {hero.headline}
          </h1>

          <p className="animate-fade-in-up delay-100 mt-6 max-w-2xl text-lg leading-relaxed text-zinc-100 sm:text-xl md:text-2xl drop-shadow-md">
            {hero.subheadline}
          </p>

          <div className="animate-fade-in-up delay-150 mt-8 flex items-center gap-3">
            <div className="h-[2px] w-8 bg-pink-500"></div>
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-pink-100 drop-shadow-md">
              {hero.shortLine}
            </p>
          </div>

          <div className="animate-fade-in-up delay-200 mt-10 flex flex-nowrap items-center gap-2 sm:gap-4">
            <Button
              href={CTA_URL}
              className="min-w-0 flex-1 whitespace-nowrap px-2 py-3 text-[10px] tracking-[0.02em] shadow-xl shadow-pink-500/20 max-[380px]:gap-1 max-[380px]:px-1.5 max-[380px]:text-[9px] max-[380px]:tracking-normal max-[380px]:[&_svg]:hidden sm:px-6 sm:py-3 sm:text-sm sm:tracking-[0.06em]"
            >
              <>
                <span className="sm:hidden">Preinscripción</span>
                <span className="hidden sm:inline">{hero.primaryCta}</span>
              </>
            </Button>
            <Button
              href={DOSSIER_URL}
              variant="secondary"
              className="min-w-0 flex-1 whitespace-nowrap border-white/90 bg-white/90 px-2 py-3 text-[10px] tracking-[0.02em] text-zinc-900 shadow-xl shadow-black/20 backdrop-blur-sm hover:border-white hover:bg-white max-[380px]:gap-1 max-[380px]:px-1.5 max-[380px]:text-[9px] max-[380px]:tracking-normal max-[380px]:[&_svg]:hidden sm:px-6 sm:py-3 sm:text-sm sm:tracking-[0.06em]"
            >
              <>
                <span className="sm:hidden">Presentación</span>
                <span className="hidden sm:inline">{hero.secondaryCta}</span>
              </>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
